module.exports = __webpack_public_path__ + "static/media/default-profile.6e37a22f.svg";


//////////////////
// WEBPACK FOOTER
// ./public/media/images/default-profile.svg
// module id = 51
// module chunks = 0